import { Common } from './common';
import { Pagination, SortOrder } from './models/common';
import { ImportValidation } from './models/provider';

import * as Broadcast from './models/broadcast';
import * as NotificationRequest from './models/notification/request';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async sendWithEncounters(
    args: Broadcast.EncounterBroadcastArgs,
  ): Promise<Broadcast.BroadcastPopulated> {
    const url = this.common.constructPath(`/broadcasts`);
    const { broadcast } = await this.common.postJSON(url, args);
    return broadcast;
  }

  async batchSendWithEncounters(
    args: Broadcast.EncounterBatchBroadcastArgs,
  ): Promise<Broadcast.BatchBroadcastResult> {
    const url = this.common.constructPath(`/broadcasts/batch-encounter`);
    return await this.common.postJSON(url, args);
  }

  async findAll(
    args: Broadcast.FindAllOptions,
  ): Promise<Pagination<Broadcast.BroadcastPopulated>> {
    const url = this.common.constructPath(`/broadcasts`, {
      ...args,
      sorts: args.sorts || [
        {
          column: 'created',
          order: SortOrder.Descending,
        },
      ],
    });
    return this.common.getJSON(url);
  }

  async template(
    values: Broadcast.BroadcastBodyValues,
  ): Promise<Broadcast.BroadcastTemplateContents> {
    const url = this.common.constructPath('/broadcasts/template');
    return this.common.postJSON(url, values);
  }

  async findOneById(id: string): Promise<Broadcast.BroadcastPopulated> {
    const url = this.common.constructPath(`/broadcasts/${id}`);
    return this.common.getJSON(url);
  }

  async findAllResults(
    args: NotificationRequest.FindAllOptions & {
      broadcastId: string;
    },
  ): Promise<Pagination<NotificationRequest.GroupedResult>> {
    const url = this.common.constructPath(
      `/broadcasts/${args.broadcastId}/requests`,
      {
        ...args,
        broadcastId: undefined,
        sorts: args.sorts || [
          {
            column: 'created',
            order: SortOrder.Descending,
          },
        ],
      },
    );
    return this.common.getJSON(url);
  }

  async import(args: Broadcast.BroadcastDataArgs): Promise<boolean> {
    const url = this.common.constructPath(`/broadcasts/data`);
    const { success } = await this.common.postJSON(url, args);
    return success;
  }

  async importVerify(args: {
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/broadcasts/data/verify`);
    return this.common.postJSON(url, args);
  }

  async processBroadcastData(): Promise<boolean> {
    const url = this.common.constructPath(`/broadcasts/data/process`);
    const { success } = await this.common.postJSON(url, {});
    return success;
  }

  async processNotificationRequest(): Promise<boolean> {
    const url = this.common.constructPath(`/notification-requests/process`);
    const { success } = await this.common.postJSON(url, {});
    return success;
  }
}
